// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59ec7e81","455":"79de38dc","977":"77068c00"}[chunkId] + ".chunk.js";
};